import { Flex } from "@chakra-ui/react";
import EnterStoreURL from "views/admin/campaign_create/roas/components/EnterStoreURL";
import CampaignDetails from "views/admin/campaign_create/roas/components/CampaignDetails";
import StepContainer from "views/admin/campaign_create/roas/components/StepContainer";
import Preview from "views/admin/campaign_create/roas/components/Preview";
import Creatives from "views/admin/campaign_create/roas/components/Creatives";
import RoasStepper from "views/admin/campaign_create/roas/components/Stepper";
import { StepProvider } from "views/admin/campaign_create/roas/components/StepContext";
import RoasTargets from "views/admin/campaign_create/roas/components/RoasTargets";
import { CampaignCreateProvider } from "views/admin/campaign_create/roas/components/CampaignCreateContext";
import { useUserPermissions } from "hooks/useUserPermissions";

// https://play.google.com/store/apps/details?id=com.itseventor&hl=en

const steps = [
  /* {
    name: "Starting Point",
    key: "starting-point",
    description:
      "Enter your store URL to automatically fetch key information for your campaign setup.",
  }, */
  {
    name: "Campaign Configuration",
    key: "campaign-configuration",
    description:
      "Define your campaign's core details, including name, budget etc.",
  },
  {
    name: "ROAS Goals",
    key: "roas-goals",
    description:
      "Set your desired Return on Ad Spend (ROAS) goals for optimal campaign performance.",
    depends: ["campaign-configuration"],
  },
  {
    name: "Creatives",
    key: "creatives",
    description:
      "Upload and manage the visual assets that will be used to promote your campaign across Gamelight platforms.",
    depends: ["campaign-configuration", "roas-goals"],
  },
  {
    name: "Overview",
    key: "review",
    description:
      "Preview your campaign configuration, make final adjustments, and launch your campaign.",
    depends: ["campaign-configuration", "roas-goals", "creatives"],
  },
];

export const AVAILABLE_WIDTH = `calc(100vw - 350px)`;

const RoasCampaignCreate = () => {
  const { isRoasCampaignsEnabled } = useUserPermissions();

  if (!isRoasCampaignsEnabled) return <></>;

  return (
    <Flex flexDir={"column"} flex={1} pt={"75px"}>
      <StepProvider steps={steps}>
        <CampaignCreateProvider>
          <StepContainer w={AVAILABLE_WIDTH} minH={`calc(88vh - 140px)`}>
            {/* <EnterStoreURL /> */}
            <CampaignDetails />
            <RoasTargets />
            <Creatives />
            <Preview />
          </StepContainer>
          <RoasStepper />
        </CampaignCreateProvider>
      </StepProvider>
    </Flex>
  );
};

export default RoasCampaignCreate;
